export default __webpack_public_path__ + "static/boulevard-f6838d85546975b8c9232fcb49040215.jpg";